
import { defineComponent, onMounted, ref } from "vue";
import dayjs from "dayjs";
import { setCurrentPageTitle } from "@/core/helpers/breadcrumb";
import { getOVICoverageInfo } from "@/api/ovi_api";

import SealProRenew from "@/views/modals/SealProRenew.vue";
import SealProEncode from "@/views/modals/SealProEncode.vue";

import DashboardTabNavigator from "@/components/dashboard/DashboardTabNavigator.vue";

export default defineComponent({
  name: "ovicoverageinfo",
  components: {
    DashboardTabNavigator,
    SealProRenew,
    SealProEncode,
  },
  props: {
    widgetClasses: String,
  },
  data() {
    return {
      sealProMaxCoverage: "",
      activeCoverage: [] as any[],
      loading: true,
      allowChangeName: false,
      renewCoverage: {} as any,
      renew_now_sealpro_key: 1,
      coverageSender: 0,
    };
  },
  methods: {
    async getOviCoverageInfo() {
      this.loading = true;
      const response = await getOVICoverageInfo();
      this.sealProMaxCoverage = response.data.sealProMaxCoverage;
      this.activeCoverage = response.data.activeCoverage;
      this.coverageSender = response.data.COVERAGE_SENDER;
      this.loading = false;
    },

    coverageBadgeClass(item: any): string {
      if (item.coveragests === "EXPIRED") return "seq-badge--danger";
      if (item.coveragests === "EXPIRING") return "seq-badge--pending";
      return "seq-badge--success";
    },

    coverageStatusLabel(item: any): string {
      if (item.coveragests === "EXPIRED") return "Expired";
      if (item.coveragests === "EXPIRING") return "Expiring Soon";
      return "Active";
    },

    formatCoverageDate(dateString: string): string {
      return dayjs(dateString).format("MMMM D, YYYY");
    },

    renewSealPro(coverage: any) {
      coverage.coverage_transtype = "RENEW";
      this.renewCoverage = coverage;
      this.renew_now_sealpro_key += 1;
      const self = this;
      setTimeout(() => {
        if (self.coverageSender == 2) {
          this.renewCoverage = coverage;
          const btn2: any = this.$refs.renewNowSealproModalButton2;
          btn2.click();
        } else {
          const btn: any = this.$refs.renewNowSealproModalButton;
          btn.click();
        }
      }, 500);
    },
  },
  mounted() {
    this.getOviCoverageInfo();
  },
  setup() {
    const tabIndex = ref(0);

    onMounted(() => {
      setCurrentPageTitle("My Coverage");
      tabIndex.value = parseInt(
        localStorage.getItem("ovicoverageinfotransferTab") || "0"
      );
    });
  },
});
